import React, { useCallback, useState } from "react";
import {
  Button,
  DashboardMenuItem,
  Menu as RaMenu,
  MenuItemLink,
  useLogout,
} from "react-admin";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import UserIcon from "@mui/icons-material/Group";
import BarChartIcon from "@mui/icons-material/BarChart";
import SchoolIcon from "@mui/icons-material/School";
import PeopleIcon from "@mui/icons-material/People";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

export const Menu: React.FC = () => {
  const logout = useLogout();
  const [learningOpen, setLearningOpen] = useState(true);

  const handleLogout = useCallback(() => {
    logout();
  }, []);

  return (
    <RaMenu>
      <DashboardMenuItem />
      <MenuItemLink to="/users" primaryText="Users" leftIcon={<UserIcon />} />

      {/* Collapsible Learning section */}
      <ListItemButton onClick={() => setLearningOpen(!learningOpen)}>
        <ListItemIcon sx={{ minWidth: 40 }}>
          <SchoolIcon />
        </ListItemIcon>
        <ListItemText primary="Learning" />
        {learningOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={learningOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <MenuItemLink
            to="/learning/overview"
            primaryText="Metrics"
            leftIcon={<BarChartIcon />}
            sx={{ pl: 4 }}
          />
          <MenuItemLink
            to="/learning-users"
            primaryText="Users"
            leftIcon={<PeopleIcon />}
            sx={{ pl: 4 }}
          />
          <MenuItemLink
            to="/curricula"
            primaryText="CMS"
            leftIcon={<EditNoteIcon />}
            sx={{ pl: 4 }}
          />
        </List>
      </Collapse>

      <Button onClick={handleLogout}>
        <>Logout</>
      </Button>
    </RaMenu>
  );
};
